import { createHazardScoreBadge } from '../ScoreBadge'
import { CanonicalPeriod, MetricState } from '..'
import { parseMetricPointY } from '../financialMetrics'

type WaterStressMetricResult = {
  state?: {
    value?: MetricState | string | null
  } | null
  data?: any | null
} | null

const waterRiskLabels: Record<number, string> = {
  1: 'Low',
  2: 'Low-Medium',
  3: 'Medium-High',
  4: 'High',
  5: 'Extremely High',
}

// const waterRiskPalette = {
//   1: '#ffffa6',
//   2: '#fbe74d',
//   3: '#f19e38',
//   4: '#ea3b24',
//   5: '#8c1911',
// }

export function normalizeWaterRiskScore(value: number | null | undefined): number | null {
  if (typeof value !== 'number' || !Number.isFinite(value) || value < 0 || value > 5) return null
  // Aqueduct scores are continuous on [0, 5], with categories [0, 1),
  // [1, 2), [2, 3), [3, 4), and [4, 5]. Display them as bands 1–5.
  // https://www.wri.org/research/aqueduct-40-updated-decision-relevant-global-water-risk-indicators
  return Math.min(Math.floor(value) + 1, 5)
}

function parseWaterStressNode(value: unknown): number | null {
  const pointValue = parseMetricPointY(value)
  if (pointValue != null) return pointValue

  if (value && typeof value === 'object' && 'value' in (value as any)) {
    return parseMetricPointY((value as any).value)
  }

  return null
}

export function parseWaterStressScore(
  entry: WaterStressMetricResult | undefined,
  tierKey: string,
  period: CanonicalPeriod,
): number | null {
  if (!entry || entry.state?.value !== MetricState.SUCCEEDED || !entry.data) return null

  const tierData = entry.data?.data?.[tierKey]
  const node = tierData?.[period] ?? tierData?.score?.[period] ?? null

  return parseWaterStressNode(node)
}

export const mapWaterRiskScore = normalizeWaterRiskScore

export const WaterRiskScoreBadge = createHazardScoreBadge({
  labels: waterRiskLabels,
  // palette: waterRiskPalette,
  mapScore: mapWaterRiskScore,
})
